import { RefreshButton } from "./RefreshButton";

export function PageHeader({ eyebrow, title, subtitle, actions, onRefresh, refreshing }) {
  return (
    <div className="mb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
      <div>
        {eyebrow && <div className="text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-2">{eyebrow}</div>}
        <h1 data-testid="page-title" className="font-display text-3xl md:text-4xl font-black tracking-tight text-slate-900">
          {title}
        </h1>
        {subtitle && <p className="mt-2 text-sm text-slate-600 max-w-2xl">{subtitle}</p>}
      </div>
      {(actions || onRefresh) && (
        <div className="flex flex-wrap items-center gap-2">
          {onRefresh && <RefreshButton onRefresh={onRefresh} loading={refreshing} />}
          {actions}
        </div>
      )}
    </div>
  );
}

export function Card({ children, className = "", ...rest }) {
  return (
    <div className={`bg-white border border-slate-200 ${className}`} {...rest}>{children}</div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    Active: "bg-emerald-50 text-emerald-800 border-emerald-200",
    Completed: "bg-blue-50 text-blue-800 border-blue-200",
    Hold: "bg-amber-50 text-amber-800 border-amber-200",
    Pending: "bg-amber-50 text-amber-800 border-amber-200",
    Partial: "bg-orange-50 text-orange-800 border-orange-200",
    "Partially Invoiced": "bg-orange-50 text-orange-800 border-orange-200",
    Paid: "bg-emerald-50 text-emerald-800 border-emerald-200",
    Approved: "bg-emerald-50 text-emerald-800 border-emerald-200",
    "Partial JMS Pulled": "bg-amber-50 text-amber-800 border-amber-200",
    "Complete JMS pulled": "bg-teal-50 text-teal-800 border-teal-200",
    "JMS Completed": "bg-indigo-50 text-indigo-800 border-indigo-200",
    "JMS and Invoice Done": "bg-violet-50 text-violet-800 border-violet-200",
    Rejected: "bg-red-50 text-red-700 border-red-200",
    Synced: "bg-blue-50 text-blue-800 border-blue-200",
    Failed: "bg-red-50 text-red-700 border-red-200",
  };
  const cls = map[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider border ${cls}`}>
      {status || "—"}
    </span>
  );
}

export function EmptyState({ title, hint, subtitle, icon: Icon, cta, testid }) {
  return (
    <div className="border border-dashed border-slate-300 bg-white p-12 text-center" data-testid={testid}>
      {Icon && (
        <div className="flex justify-center mb-3 text-slate-400">
          <Icon size={28} strokeWidth={1.5} />
        </div>
      )}
      <div className="font-display text-lg font-bold text-slate-700">{title}</div>
      {(hint || subtitle) && <div className="text-sm text-slate-500 mt-1">{hint || subtitle}</div>}
      {cta && (
        <button
          type="button"
          onClick={cta.onClick}
          className="mt-5 bg-[#F97316] text-white text-xs uppercase tracking-wider font-bold px-4 py-2"
        >
          {cta.label}
        </button>
      )}
    </div>
  );
}
